var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13 12.25c-.63 0-1.13-.5-1.13-1.13v-6A1.13 1.13 0 0 1 3.13 4h9.75A1.13 1.13 0 0 1 14 5.13v6c0 .62-.5 1.12-1.13 1.12H3.13Zm-.38-1.13c0 .21.17.38.38.38h9.75c.2 0 .37-.17.37-.38v-5.9l-2.8 1.94L12 8.6a.38.38 0 0 1-.5.55L9.8 7.59l-.9.63a1.57 1.57 0 0 1-1.8 0l-.9-.63-1.7 1.56a.38.38 0 0 1-.53-.02A.38.38 0 0 1 4 8.6l1.57-1.44-2.81-1.94v5.9ZM7.53 7.6a.83.83 0 0 0 .94 0l4.14-2.85H3.39L7.53 7.6Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.49dc0a66baac700e66a56b0f0376ad2c.svg";
export { ForwardRef as ReactComponent };